import Backdrop from "@mui/material/Backdrop";
import { LoadingScene } from "./loading-scene";

interface LoadingSceneBackdropProps {
	fallbackLogoUrl?: string;
	logoUrl?: string;
}

export const LoadingSceneBackdrop = ({
	fallbackLogoUrl,
	logoUrl,
}: LoadingSceneBackdropProps) => {
	return (
		<Backdrop
			open
			invisible
			data-testid="LoadingBackdrop">
			<LoadingScene
				fallbackLogoUrl={fallbackLogoUrl}
				logoUrl={logoUrl}
			/>
		</Backdrop>
	);
};
